import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { useMultiCollectionSupportContext } from '../MultiCollectionSupportProvider';
import { EmptyStateBase, EmptyStateBaseProps } from './EmptyStateBase';
import { PremiumEmptyStateIllustration } from '../Illustration/PremiumEmptyStateIllustration';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { useToolbarCollectionEmptyStateTexts } from '../../hooks/useToolbarCollectionEmptyStateTexts';
import { PremiumButton, PremiumButtonProps } from './PremiumButton';
import { useToolbarCollectionEmptyStateImage } from '../../hooks/useToolbarCollectionEmptyStateImage';

export interface PremiumEmptyStateProps
  extends Omit<Partial<EmptyStateBaseProps>, 'cta'>,
    PremiumButtonProps {
  children?: ReactNode;
}

function _PremiumEmptyState(props: PremiumEmptyStateProps) {
  const state = useMultiCollectionSupportContext();
  const { image: customImage, premiumBtnText, onPremiumBtnClick } = props;
  const { translate: t } = useWixPatternsContainer();

  const image = useToolbarCollectionEmptyStateImage({
    state,
    image:
      customImage === undefined ? (
        <PremiumEmptyStateIllustration data-hook="empty-state-premium-illustration" />
      ) : (
        customImage
      ),
  });

  const { title, subtitle, cta } = useToolbarCollectionEmptyStateTexts({
    state,
    title: t('cairo.emptyState.premium.title'),
    subtitle: t('cairo.emptyState.premium.text'),
    cta: (
      <PremiumButton
        premiumBtnText={premiumBtnText}
        onPremiumBtnClick={onPremiumBtnClick}
      />
    ),
  });

  return (
    <EmptyStateBase
      dataHook="premium-empty-state"
      title={title}
      subtitle={subtitle}
      image={image}
      cta={cta}
      {...props}
    />
  );
}

export const PremiumEmptyState = observer(_PremiumEmptyState);
